import { render, staticRenderFns } from "./TranscriptionSpan.vue?vue&type=template&id=11355a6c"
import script from "./TranscriptionSpan.vue?vue&type=script&lang=js"
export * from "./TranscriptionSpan.vue?vue&type=script&lang=js"
import style0 from "./TranscriptionSpan.vue?vue&type=style&index=0&id=11355a6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports